import { createTheme, type ThemeOptions } from "@mui/material";

const customTheme = createTheme({
    palette: {
        mode: "dark",
        spacing: 5,
        background: {
            default: '#0A0B0C', // page canvas (deepest black)
            paper: '#121416'    // MUI Paper / section containers (black, subtle lift over canvas)
        },
        primary: {
            darkest: '#324656',
            darker: '#4B88AD',
            dark: '#6D9ABC',
            main: '#A2CDED',
            light: '#91D0FF',
            lighter: '#D8EEFF'
        },
        secondary: {
            // Brand accent (escala de azul StreamFin) — substitui o dourado off-brand.
            main: '#80AFD1',    // Pantone 2169 C
            light: '#A6C8E1',   // Pantone 543 C
            lighter: '#DAEAF7'  // Pantone 656 C
        },
        tertiary:{
            main: '#853C7F',
            light: '#BD6DB6'
        },
        neutral: {
            darkest: '#1E2224', // content cards (MUI Box) — dark gray, sits above the black Paper sections
            darker: '#2C3133',  // controls: inputs, app bar, tabs (one step lighter than content cards)
            dark: '#686661',
            main: '#B9B3AA',
            light: '#B9B3AA',
            lighter: '#FFFFFF'
        },
        accentInfo: {
            main: '#79A7FF' // autogenerated
        },
        accentSuccess: {
            main: '#79FF8B'
        },
        accentWarning: {
            // Sem amarelo na marca: estado "warning" passa a usar o azul de acento.
            main: '#80AFD1',
            light: '#A6C8E1'
        },
        accentError: {
            main: '#FF7979'
        },
    },
    typography: {
        // Use Satoshi as the preferred font; fall back to system fonts
        fontFamily: '"Satoshi-Variable", "Satoshi-Regular", "Segoe UI", "Segoe", system-ui, -apple-system, "Helvetica Neue", Arial, sans-serif',
        sizes: {
            xs: "0.75rem",
            sm: "0.875rem",
            md: "1rem",
            lg: "1.125rem",
            xl: "1.25rem",
            body: "16px",
            h1: "32px",
            h2: "24px",
            h3: "16px",
            h4: "16px",
            h5: "16px"
        },
        lineHeights:{
            h1: '36px',
            h2: '24px',
            h3: '20px',
            caption: '18px'
        },
        weights:{
            bolder: '700',
            bold: '500',
            regular: '400',
            thin: '200'
        }

    },
    shape: {
        border: {
            general: {
                radius: [
                    "none",
                    "1px",
                    "2px",
                    "3px",
                    "4px",
                    "5px",
                    "6px",
                    "7px",
                    "8px",
                    "16px"
                ],
                style: {
                    default: "solid"
                },
                width: [
                    "1px",
                    "2px",
                    "3px",
                    "4px"
                ],
                thickness: [
                    "0px",
                    "1px",
                    "1.5px",
                    "2px"
                ]
            },
            button: {
                radius: ['0px', '4px', '6px', '8px', '12px', '16px']
            }
        },
    },
    customShadows: [
        "none",
        "0px 1px 2px rgba(0,0,0,0.05)",
        "0px 2px 4px rgba(0,0,0,0.08)"
    ],
    components: {
        // Sober, squared-off look across the interface: 4px radius everywhere.
        MuiChip: {
            styleOverrides: {
                root: { borderRadius: 4 },
            },
        },
        // Removes the ripple ("flash") effect from every clickable button/control in the app.
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
} as unknown as ThemeOptions);

export { customTheme };
